











































































import NoResults from "@/components/ui/NoResults.vue";

import { Component, Prop } from "vue-property-decorator";
import BaseInternalSheetValorization
    from "@/components/pages/valorizations/internal/observatory/BaseInternalSheetValorization.vue";

@Component({
  components: {
    NoResults
  }
})
export default class PatrimonialSheetOneSheet extends BaseInternalSheetValorization {
  protected columnNames = {
    name: "Nom",
    interest: "Intérêt",
    priority_interest: "Espèce communautaire prioritaire",
    community_interest: "Espèce communautaire",
    protected: "Espèce protégée",
    region: "Région",
    date: "Date"
  };
  protected items = [];
  columns = [];
  url =
    "/valorization/observatory/flora/patrimonial-sheet-one";


  drawData() {
    this.data = this.data.length > 0 ? this.data : [];
  }
}
